import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderTypeLookupComponent } from './order-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [OrderTypeLookupComponent],
  exports: [OrderTypeLookupComponent]
})
export class OrderTypeLookupModule { }
